module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAABHNCSVQICAgIfAhkiAAAAVVJREFUWEftll8NwjAQxlcB2AABCEABBhBAeEcA8A7vgAEEgIAJwAAYQAACxl1yTZpm7XdtF7KHNmlG6O7623d/WtOMZJiRcDQVxI9EVaQqgqoT5kjXdUtysqPZ0jwYY77IKa+T3YQeR5pzsbvH7DQgT8fBi35vEIxAnOndmdi+yWZVCnIiBwstTA8Em94IhP0Eh0YRlvhCc4pgAhAPgtijcEIQJ95RmBII3kMFgmDka92c4L9USlil1CAAhpdtYiZDJCliySUEfpjcFEhSIksRBUwWRJYiToj8nOAlVZ/pq6CkHAEQ1n8WTBJIqESlx8A+E+slapBYnwgkcJIyKhBNsyqFgSAaCFBNKmU0INwz+Ci3I1qiAWVgWWtA3GsAdBjowB86+PheExwaEHawptmio9zdRZTZippXsi27GMW+Ysg1qMiQmxWFpoL8SwF/n5ojo1XkBxlnoCOKy37hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/close.png
// module id = cD5h
// module chunks = 3